import { Component, Input } from '@angular/core';
import { RegisterPermissionType } from '@assetaccountant/api/models/register-permission-type';
import { DraftAsset } from '@assetaccountant/assets/models/draft-asset';
import { isPremiumIntegrationFeature } from '@assetaccountant/core/utils/feature-utils';
import { DraftAssetsListComponent } from '../draft-assets-list.component';

export interface DraftAssetListActionCellRendererParams {
  context: {
    componentParent: DraftAssetsListComponent;
  };
}

@Component({
  selector: 'app-draft-asset-list-action-cell',
  templateUrl: './draft-asset-list-action-column.component.html',
  standalone: false,
})
export class DraftAssetListActionCellComponent {
  readonly isPremiumIntegrationFeature = isPremiumIntegrationFeature;
  readonly RegisterPermissionType = RegisterPermissionType;

  @Input() data: DraftAsset;
  @Input() componentParent: DraftAssetsListComponent;

  get hasCreateAssetsPermission() {
    return this.componentParent?.hasCreateAssetsPermission ?? false;
  }
  get integrationType() {
    return this.componentParent?.integrationType;
  }

  get isIgnored() {
    return this.data.isIgnored;
  }
  get updating() {
    return this.data._updating ?? false;
  }

  addAsset() {
    this.data._updating = true;
    this.componentParent.onAddAsset(this.data);
  }

  addCost() {
    this.data._updating = true;
    this.componentParent.onAddCost(this.data);
  }

  onIgnore() {
    this.data._updating = true;
    this.componentParent.onIgnoreDraftAsset(this.data);
  }
}
